// extracted by mini-css-extract-plugin
export var body = "_la-0";
export var sectionHeader = "_la-4";
export var shortcutColumns = "_la-2";
export var shortcutList = "_la-1";
export var shortcutSection = "_la-3";